// Range slider
const updateRangeSlider = (ev: Event) => {
  const input = ev.target as HTMLInputElement;
  input.style.backgroundSize = ((parseFloat(input.value) - parseInt(input.min)) * 100) / (parseInt(input.max) - parseInt(input.min)) + '% 100%';
};
export default function rangeSlider(input: HTMLInputElement) {
  if (input.type !== 'range') {
    return;
  }
  input.addEventListener('input', updateRangeSlider);
  input.addEventListener('update', updateRangeSlider);
  input.dispatchEvent(new Event('input'));
}
